import React from 'react';
import PropTypes from 'prop-types';
import { useSelector } from "react-redux";
import { Spinner } from "components";
import PreviewMediaUrls from "./PreviewMediaUrls";
import UserNavPanel, { UserNavPanelPropTypes } from "./UserNavPanel";

const BrandHeader = ({
  children,
  containerProps,
  showPreviewMedia = true,
  showVideoAmbientEffect = true,
  hideUserNavPanel = true,
  showImageAmbientEffect = true,
  navPanelContainerstylesProps = {},
  videoProps = {},
  imageProps = {},
  userNavPanelProps = {}
}) => {
  const { brandInfo } = useSelector((state) => state?.brandStorageReducer);
  const { isLoading } = useSelector((state) => state?.loader);

  if (isLoading) return <Spinner />;

  const getMediaSource = () => {
    if (brandInfo?.setting?.showBannerVideo) {
      return brandInfo?.setting?.brandVideoHomeBG;
    }
    return brandInfo?.setting?.brandImageHomeBG;
  };

  return (
    <div
      {...containerProps}
      className={`relative bg-cover w-full bg-center overflow-hidden pb-56p ${containerProps?.className ?? ""}`}
    >
      {!hideUserNavPanel && (
        <div className={`absolute top-0 left-0 p-4 w-full ${navPanelContainerstylesProps?.className ?? ""}`}
          {...navPanelContainerstylesProps}
          
        >
          <UserNavPanel {...userNavPanelProps} />
        </div>
      )}
      {showPreviewMedia && (
        <div className="absolute top-0 left-0 w-full h-full"
          style={{
            zIndex: "-10",
          }}
        >
          <PreviewMediaUrls
            sourceUrl={getMediaSource()}
            showVideoAmbientEffect={showVideoAmbientEffect}
            showImageAmbientEffect={showImageAmbientEffect}
            videoProps={videoProps}
            imageProps={imageProps}
          />
        </div>
      )}
      {children ?? null}
    </div>
  );
};

BrandHeader.propTypes = {
  children: PropTypes.node,
  containerProps: PropTypes.object,
  showPreviewMedia: PropTypes.bool,
  showVideoAmbientEffect: PropTypes.bool,
  hideUserNavPanel: PropTypes.bool,
  showImageAmbientEffect: PropTypes.bool,
  videoProps: PropTypes.object,
  imageProps: PropTypes.object,
  userNavPanelProps: PropTypes.shape(UserNavPanelPropTypes),
};

BrandHeader.defaultProps = {
  showPreviewMedia: true,
  showVideoAmbientEffect: true,
  hideUserNavPanel: true,
  showImageAmbientEffect: true,
  videoProps: {},
  imageProps: {},
};

export default BrandHeader;
